module.exports = __webpack_public_path__ + "media/src/img/twitter-icon-798142c6fd2bb87f36ba64f37c7073cd.svg";